/**
 * Deterministic colour from text, computed IN THE BROWSER from what the page already holds: the
 * generated face (`audio/head.ts`, for a player whose skin the server did not send) and the mailbox's
 * item glyphs (`ItemGlyph`).
 *
 * WHY IT IS DETERMINISTIC. The same account and the same item must look the same on every device and
 * every reload, so everything here is a pure function of its input — no randomness, no storage, no
 * clock — and nothing in it is reversible into what it was computed from.
 *
 * WHAT IS NOT HERE ANY MORE: a monogram. The tile Stats' header used to draw spelled two letters of
 * the player's name, and with no name to hand it spelled two characters of the UUID — so a player
 * whose directory row had not loaded was greeted as "90". The header now shows the player's face
 * instead, from the claim's skin hash or generated as pixels, and no code path prints UUID text.
 */

/**
 * FNV-1a, 32-bit. Chosen for being four lines of arithmetic with a good spread over short strings
 * and no dependency; it is not and must not be used as a security primitive.
 */
export function hashText(value: string): number {
  let hash = 0x811c9dc5;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    // Multiply by the FNV prime (16777619) in 32-bit space, via shifts, so the result stays exact.
    hash = (hash + (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24)) >>> 0;
  }
  return hash >>> 0;
}

/** A hue in [0, 360) for any text. Used for the mailbox item glyphs. */
export function hueOf(value: string): number {
  return hashText(value) % 360;
}
